module.exports = __webpack_public_path__ + "static/media/main.5a5750c8.png";